(function(){
  var CDN = 'https://cdn.shopify.com/s/files/1/0754/6860/3446/t/3/assets/';
  
  // ── Vibe category grid ────────────────────────────────────
  function applyVibeImages() {
    var section = document.getElementById('shopify-section-template--21411470278710__category');
    if (!section) {
      // fallback: find by class
      section = document.querySelector('.inkhaus-catgrid-section');
    }
    if (!section) return;

    var tiles = section.querySelectorAll('.ikcat__tile');
    var vibeMap = {
      'Nurses': 'vibe-nurses.png',
      'Healthcare': 'vibe-nurses.png',
      'Dog': 'vibe-dog-moms.png',
      'Pet': 'vibe-dog-moms.png',
      'Gym': 'vibe-gym.png',
      'Fitness': 'vibe-gym.png',
      'Dark': 'vibe-dark-humor.png',
      'Humor': 'vibe-dark-humor.png',
      'Festival': 'vibe-festival.png',
      'Nightlife': 'vibe-festival.png',
      'Custom': 'vibe-custom-tees.png',
      'Tee': 'vibe-custom-tees.png'
    };
    var fallback = ['vibe-nurses.png','vibe-dog-moms.png','vibe-gym.png','vibe-dark-humor.png','vibe-festival.png','vibe-custom-tees.png'];

    tiles.forEach(function(tile, idx) {
      // Skip if image already applied
      if (tile.querySelector('.ikcat__img')) return;
      var placeholder = tile.querySelector('.ikcat__placeholder');
      
      // Determine which image to use
      var label = tile.querySelector('.ikcat__label');
      var labelText = label ? label.textContent.trim() : '';
      var ariaLabel = tile.getAttribute('aria-label') || '';
      var text = labelText + ' ' + ariaLabel;
      
      var imgFile = fallback[idx % fallback.length];
      for (var key in vibeMap) {
        if (text.indexOf(key) > -1) { imgFile = vibeMap[key]; break; }
      }
      
      var img = document.createElement('img');
      img.className = 'ikcat__img';
      img.src = CDN + imgFile;
      img.alt = labelText || ariaLabel;
      img.loading = 'lazy';
      
      if (placeholder) {
        placeholder.parentNode.replaceChild(img, placeholder);
      } else {
        tile.insertBefore(img, tile.firstChild);
      }
    });
  }

  // ── Hero background image ─────────────────────────────────
  function applyHeroImage() {
    var heroSection = document.querySelector('.ikh-hero');
    if (!heroSection) return;
    // Only add if no bg image exists
    if (heroSection.querySelector('.ikh-hero__bg')) return;
    var bg = document.createElement('img');
    bg.className = 'ikh-hero__bg';
    bg.src = CDN + 'hero-bg.png';
    bg.alt = 'INKHAUS streetwear editorial';
    bg.loading = 'eager';
    heroSection.insertBefore(bg, heroSection.firstChild);
  }

  function init() {
    applyVibeImages();
    applyHeroImage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();